export default {
  heading: {
    widgetName: "Tiktok-Value-Packs",
    widgetID: "107",
    widgetWidth: "3",
    cardCount: "4",
    layoutName: "lob_widget",
    headline: "Coffee & Tea",
    headlineType: "h2",
    subHeadline: "",
    showMoreURL: "",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `Grocer Campaign | Grocer in Penang`,
      eventLabelCardClick: `Grocer in Penang | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
      eventLabelHeadlineClick: `Grocer in Penang | headline | {{headline}}`,
      eventLabelView: `Grocer in Penang`,
    },
  },

  data: [
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/TelukKumbar.jpg",
      title: "Carrot Mart - Teluk Kumbar",
      subtitle: "Your grocery needs right at your fingertips",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/merchant/penang-delivery-carrot-mart-teluk-kumbar"
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/coffee-factory.jpg",
      title: "Sin Boon Kee Coffee Factory",
      subtitle: "Coffee specialist since the 1940s ",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/merchant/penang-delivery-sin-boon-kee-coffee-factory"
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/salute-brand.jpg",
      title: "Salute Brand Coffee & Tea",
      subtitle: "Local kopi-o since 1952 ",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/merchant/penang-delivery-salute-brand-coffee-and-tea"
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/cheong-kim-chuan.jpg",
      title: "Cheong Kim Chuan",
      subtitle: "Preserved fruits, Tau Sar Pneah, sauces, condiments, beverages and more",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/merchant/penang-delivery-cheong-kim-chuan"
    },
    
  ],
}
